import React from 'react';
import { Link } from 'react-router-dom';
import { useUserContext } from '../context';
import './index.scss';

function UserPublicEntities() {
  const { userData } = useUserContext();
  const { entities } = userData;

  if (!entities) {
    return null;
  }

  return (
    <div className="user-public-entities">
      <h2 className="entities-title">{userData.name}'s Public Entities</h2>
      { entities.map(entity => {
        return (
          <div key={entity.name} className="entity-item">
            <div className="entity-main">
              <h3 className="entity-name">
                <Link to={`/${userData.username}/entity/${entity.id}`}>
                  { entity.name }
                </Link>
              </h3>
              <span className="entity-visibility">Public</span>
            </div>
            <div className="entity-meta">
              Updated {new Date(entity.updatedAt).toLocaleDateString()}
            </div>
          </div>
        );
      }) }
    </div>
  );
}

export default UserPublicEntities;
